import { IMarkAvailableSpotRequest } from "./types";
import { IRepoErrors } from "@/v2/repo/errors";
import { AxiosResponse } from "axios";
import { http } from "../../http";

export class MarkAvailableSpotError extends Error {
  errors: IRepoErrors;

  constructor(errors: IRepoErrors) {
    super("Error in repo: MarkAvailableSpot");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

export async function markAvailableSpot(
  request: IMarkAvailableSpotRequest
): Promise<boolean> {
  let response: AxiosResponse;

  try {
    response = await http.put(
      `api/v3/outlets/${request.outletId}/tables/${request.spotId}/mark-as-available`
    );
  } catch (e: any) {
    const isAxiosError = Boolean(e?.isAxiosError);

    if (!isAxiosError) {
      throw e;
    }

    throw new MarkAvailableSpotError(e);
  }

  return Boolean(response);
}
